import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { ENV_NAME, IS_TEST, RELEASE_VERSION, SENTRY_DNS, TCHOP_ROOT_URL } from '../../env';

Sentry.init({
  dsn: SENTRY_DNS,
  integrations: [
    new BrowserTracing({
      tracePropagationTargets: [TCHOP_ROOT_URL],
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      ),
    }),
  ],
  tracesSampleRate: 0.1,
  environment: ENV_NAME,
  release: RELEASE_VERSION,
  enabled: !IS_TEST,
  debug: false,
  normalizeDepth: 15,
});

export const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options listed below
});
